import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

// The result of each upload queued with a resultKey (see processFileAndUpload),
// so a caller can wait for its own file rather than any upload finishing.
export const useUploadResultsStore = create(
  subscribeWithSelector((set) => ({
    results: {}, // { [resultKey]: { status: 'done', imageId } | { status: 'failed' } }
    setResult: (key, result) =>
      set((state) => ({ results: { ...state.results, [key]: result } })),
    clearResult: (key) =>
      set((state) => {
        const results = { ...state.results };
        delete results[key];
        return { results };
      }),
  })),
);
